<template>
  <div>
    <section-title
      container-class="my-2 whodas-title"
      content="Resultados obtenidos en el instrumento por dominio WHODAS 2.0"
      icon="fas fa-file"
      reverse
    />

    <levels :value="levels" />

    <div class="mt-3">
      <section-title
        content="Los resultados obtenidos por el evaluado son los siguientes:"
        has-line
      />
      <div v-for="item in areasByEvaluatedResults" :key="item.area.id">
        <answer
          :is-read-only="isReadOnly"
          :levels="levels"
          :value="item"
          @input="onAnswer(item, $event)"
        />
      </div>
    </div>

    <div class="my-3">
      <label class="data-name">
        El perfil del evaluado refleja lo siguiente:
      </label>
      <custom-text-area
        v-model="model.comment"
        :count-classes="['d-block', 'small-counter']"
        :disabled="isReadOnly"
        :maxlength="3000"
        show-char-count
      />
    </div>
    <div>
      <section-title
        content="Códigos de la CIF representados en los hallazgos del WHODAS:"
        has-line
      />
      <div v-for="item in areasByWhodasCifCodes" :key="item.area.id">
        <answer
          :is-read-only="isReadOnly"
          :value="item"
          @input="onAnswer(item, $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import alertMixin from '@/mixins/alert.mixin.js';

import SectionTitle from '@/shared/components/SectionTitle.vue';
import CustomTextArea from 'CustomTextArea';

import Levels from './components/Levels.vue';
import Answer from './components/AreaAnswer.vue';

import { getDisabilityEvaluationQuestionnaireLevels as getLevels } from '@/modules/vocational-evaluation/api.js';
import Instruments from '@/utils/constants/vocationalEvaluationInstrumentEnum';

import Categories from '@/utils/constants/vocationalEvaluationInstrumentAreaCategory.js';

export default {
  name: 'DisabilityEvaluationQuestionnaire',
  components: {
    SectionTitle,
    CustomTextArea,
    Levels,
    Answer,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      levels: [],
    };
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    areasByEvaluatedResults() {
      return this.areasByCategory(Categories.EvaluatedResults);
    },
    areasByWhodasCifCodes() {
      return this.areasByCategory(Categories.WhodasCifCodes);
    },
  },
  async mounted() {
    await this.getLevels();
    this.$emit('update:initialModel', this.model);
  },
  methods: {
    async getLevels() {
      try {
        const { data } = await getLevels(
          Instruments.DisabilityEvaluationQuestionnaire
        );
        this.levels = data;
      } catch (error) {
        this.showErrorMessage('Error al cargar los niveles de discapacidad');
      }
    },
    areasByCategory(category) {
      return (this.model.areas ?? []).filter(
        (x) => x.area?.category === category
      );
    },
    onAnswer(item, value) {
      const index = this.model.areas.findIndex(
        (a) => a.area?.id === item.area.id
      );
      if (index !== -1) {
        this.model.areas[index] = value;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .whodas-title .dot {
  background-color: white !important;
}
::v-deep .whodas-title .dot .title-icon {
  color: #ff7058 !important;
}
</style>
